import { FontFaces } from '../../learn/constants/font-faces.ts';

import OpenDyslexic3Bold from '../assets/fonts/OpenDyslexic3-Bold.ttf';
import OpenDyslexicThreeCustom from '../assets/fonts/OpenDyslexic3-Custom.ttf';
import OpenDyslexic3Regular from '../assets/fonts/OpenDyslexic3-Regular.ttf';
import {
  PreloadableAssetType,
  FontWeight,
  FontStyle,
  FontFormat,
  FontPreloadableAsset,
} from '../types/asset/preloading.types.ts';

const EASY_TO_READ_BASE_FONT_FAMILY = 'OpenDyslexic3';
const EASY_TO_READ_BOLD_FONT_FAMILY = `${EASY_TO_READ_BASE_FONT_FAMILY}-Bold`;
const EASY_TO_READ_CUSTOM_FONT_FAMILY = `${EASY_TO_READ_BASE_FONT_FAMILY}-Custom`;

export const FONT_FAMILIES = {
  [FontFaces.SERIF]: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
  [FontFaces.EASY_READ]: `${EASY_TO_READ_CUSTOM_FONT_FAMILY}, sans-serif`,
};

export const FONT_CONFIGS: FontPreloadableAsset[] = [
  {
    type: PreloadableAssetType.Font,
    url: OpenDyslexic3Regular,
    fontFamily: EASY_TO_READ_BASE_FONT_FAMILY,
    fontWeight: FontWeight.Normal,
    fontStyle: FontStyle.Normal,
    fontFormat: FontFormat.TTF,
  },
  {
    type: PreloadableAssetType.Font,
    url: OpenDyslexic3Bold,
    fontFamily: EASY_TO_READ_BOLD_FONT_FAMILY,
    fontWeight: FontWeight.Bold,
    fontStyle: FontStyle.Normal,
    fontFormat: FontFormat.TTF,
  },
  {
    type: PreloadableAssetType.Font,
    url: OpenDyslexicThreeCustom,
    fontFamily: EASY_TO_READ_CUSTOM_FONT_FAMILY,
    fontWeight: FontWeight.Normal,
    fontStyle: FontStyle.Normal,
    fontFormat: FontFormat.TTF,
  },
];
